import Model from 'offline/stream/model/base'

export default Model.extend({
	table: 'designer',
	prefix: 'designer',
	key: 'designer_id',
	fields: {
		designer_id: Model.SCHEMA_NUMBER,
		designer_name: Model.SCHEMA_TEXT
	},
	methods: {
		to_array: function() {
			return {
				designer_id: this.get_id(),
				designer_name: this.rawData().designer_name
			}
		}
	}
})
